// eslint-disable-next-line
import React from 'react';

import { useFormikContext } from 'formik';
import { WizardControls } from '../Wizard';
import { disableSubmit as shouldDisabledSubmit } from './helpers';

type Props = {
  disableSubmit?: boolean;
  submitButtonText?: string;
  onClickPreviousStep?: () => any;
  onClickNextStep?: (values) => any;
};

const WizardControlsWithFormik: React.FC<Props> = ({
  disableSubmit,
  submitButtonText,
  onClickPreviousStep,
  onClickNextStep,
}) => {
  const formik = useFormikContext();
  const isDisabledSubmit = disableSubmit ?? shouldDisabledSubmit(formik);

  const handleNextStep = () => {
    if (onClickNextStep) {
      onClickNextStep(formik.values);
    }
  };

  return (
    <WizardControls
      disableSubmit={isDisabledSubmit}
      submitButtonText={submitButtonText}
      onClickPreviousStep={onClickPreviousStep}
      onClickNextStep={() => handleNextStep()}
      insideForm
    />
  );
};

export default WizardControlsWithFormik;
